import React from 'react';

const LoginError = ({ error }) => {
  if (!error) return null;

  return (
    <div className="mb-6" role="alert" aria-live="assertive">
      <div className="flex items-start rounded-2xl border border-red-200/60 bg-red-50/50 backdrop-blur-sm px-4 py-3 shadow-[inset_1px_1px_2px_rgba(0,0,0,0.02),inset_-1px_-1px_2px_rgba(255,255,255,0.8)]">
        <span className="mt-0.5 text-red-500">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
            className="h-5 w-5"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M8.257 3.099c.765-1.36 2.721-1.36 3.486 0l6.518 11.585c.75 1.333-.214 2.991-1.742 2.991H3.48c-1.528 0-2.492-1.658-1.742-2.991L8.257 3.1zm2.996 10.9a1.25 1.25 0 11-2.506 0 1.25 1.25 0 012.506 0zm-.256-6.25a1 1 0 00-1.988 0l.31 3.75a.69.69 0 001.368 0l.31-3.75z"
              clipRule="evenodd"
            />
          </svg>
        </span>
        <p className="ml-3 text-sm leading-5 text-red-700 font-medium">
          {error}
        </p>
      </div>
    </div>
  );
};

export default LoginError;
